import { AnbEnvironmentEnum } from '@anb/ng-core';

export const ENVIRONMENT = {
  productionBuild: true,
  anbEnvironment: AnbEnvironmentEnum.prd,
  loginPath: '/api/v1/auth/authorize',
  logoutPath: '/api/v1/auth/logout',
  tokenPath: '/api/v1/auth/token',
  policiesPath: '/api/v1/auth/me/policies',
  API_BASE_PATH: 'https://api.natuurenbos.vlaanderen.be/backoffice/afschotmelding',
  configuratieServiceUri: 'https://configuratie-api.natuurenbos.be',
  vlaanderenLayer:
    'https://api.natuurenbos.vlaanderen.be/backoffice/afschotmelding/api/v1/GisProxy/reroute/arcgis/rest/services/Wildschade/Wildschade_extra/MapServer/',
  faunaBeheerZoneGemeente:
    'https://api.natuurenbos.vlaanderen.be/backoffice/afschotmelding/api/v1/GisProxy/reroute/arcgis/rest/services/WIZapp/WIZapp/MapServer/',
};
